import type { Timestamp } from 'firebase/firestore';

export const FORUM_CATEGORIES = ['Beslenme', 'Uyku', 'Sağlık', 'Genel'] as const;

export type ForumCategory = (typeof FORUM_CATEGORIES)[number];

/** `forum_posts/{postId}` */
export interface ForumPostDoc {
  id: string;
  authorId: string;
  isAnonymous: boolean;
  title: string;
  content: string;
  category: ForumCategory;
  createdAt: Timestamp;
  likedBy: string[];
  commentCount: number;
}

/** `forum_posts/{postId}/comments/{commentId}` */
export interface ForumCommentDoc {
  id: string;
  authorId: string;
  isAnonymous: boolean;
  content: string;
  createdAt: Timestamp;
  likedBy: string[];
}
